module.exports = __webpack_public_path__ + "media/images/athletes/1792-64754c8daddf6c861695eda980af77aa.png";